export interface FaroIgnoreEnv {
    REACT_APP_FARO_URL?: string
    REACT_APP_FARO_TRACE_URL?: string
}

const FARO_INGEST_PATH = /\/i\/v0\/e\/?(\?|$)/
const ROLLBAR_ITEM_API = /api\.rollbar\.com\/api\/1\/item\/?/

const escapeRegExp = (value: string): string =>
    value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

const appendUrlIgnorePatterns = (urls: Array<string | RegExp>, urlValue?: string): void => {
    if (!urlValue) {
        return
    }

    urls.push(new RegExp(escapeRegExp(urlValue)))

    try {
        const hostname = new URL(urlValue).hostname
        if (hostname) {
            urls.push(new RegExp(escapeRegExp(hostname)))
        }
    } catch {
        // Invalid URL — full-string pattern above still applies
    }
}

const getFaroIgnoreEnvFromProcess = (): FaroIgnoreEnv => ({
    REACT_APP_FARO_URL: process.env.REACT_APP_FARO_URL,
    REACT_APP_FARO_TRACE_URL: process.env.REACT_APP_FARO_TRACE_URL
})

export const getFaroIgnoreUrls = (env: FaroIgnoreEnv = getFaroIgnoreEnvFromProcess()): Array<string | RegExp> => {
    const urls: Array<string | RegExp> = [
        FARO_INGEST_PATH,
        ROLLBAR_ITEM_API
    ]

    appendUrlIgnorePatterns(urls, env.REACT_APP_FARO_URL)
    appendUrlIgnorePatterns(urls, env.REACT_APP_FARO_TRACE_URL)

    return urls
}
